module.exports = __webpack_public_path__ + "static/music-v6.c339e8a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/music-v6.png
// module id = 355
// module chunks = 35783957827783